/*
 * File Created: Wednesday, 4th January 2023 12:35:17 pm
 * Author: Chenzier Kabrabam
 * Copyright (c) - 2018-2023 Addble Solutions Private Limited. All Rights Reserved.
 */

import { Box, Theme, Typography, useTheme } from '@mui/material';
import React from 'react';
import { MdArrowRightAlt } from 'react-icons/md';
import { useNavigate } from 'react-router';
import Button from '../components/Button';
// import Appbar from '../components/head/appbar';

const PageNotFound: React.FC = (): JSX.Element => {
  const theme: Theme = useTheme();
  const navigate = useNavigate();

  const handleBackToggle = () => {
    console.log('click started');
    if (window.history.state > 0) {
      console.log('has history going back to -1');
      navigate(-1);
    } else {
      console.log('has no history going to home');
      navigate('/');
    }
  };
  return (
    <>
      {/* <Appbar color='#000' /> */}
      <Box
        sx={{
          height: '85vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: { xs: theme.spacing(0, 1, 2, 1), lg: theme.spacing(0, 8, 0, 8) },
        }}
      >
        <Box>
          <Typography
            variant='h1'
            sx={{
              fontWeight: 'bold',
              background: '-webkit-linear-gradient(175deg, rgba(194,194,194,1) 43%, rgba(239,239,239,1) 57%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}
          >
            404
          </Typography>
          <Typography variant='h4' fontWeight="bold" >Oops...!</Typography>
          <Typography variant='h5' aria-hidden={false} style={{margin: "8px 0 0 0"}} >We can't seems to find what you are looking for...!</Typography>
        </Box>
        <Box
          sx={{
            padding: theme.spacing(5, 0),
          }}
        >
          <Button title='Go back' endIcon={<MdArrowRightAlt style={{margin: "0 0 0 8px"}} />} onClick={handleBackToggle} />
        </Box>
      </Box>
    </>
  );
};

export default PageNotFound;
